import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import { Provider } from "react-redux";
import "../src/assets/stylesheets/vendor/bootstrap.min.css";
import { keepTheme } from "./utils/themes";
import store from "./store";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "animate.css";
import "../src/assets/stylesheets/main.scss";


const createHistory = require("history");

function App() {
  keepTheme();
  return (
    <>
      <Provider store={store}>
        <Router history={createHistory}>
          <ReactNotifications />
          <AppRouter />
        </Router>
      </Provider>
    </>
  );
}

export default App;
